export default __webpack_public_path__ + "static/2.5.4/media/noFundsModal.97213aef.svg";